import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import FormHelperText from '@mui/material/FormHelperText';

import SmsDialog, { SMS_DIALOG_VARIANT_CREATE_PAYMENT } from 'cityads-v3/components/Dialog/SmsDialog';
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import {
  setCode,
  resetSmsState,
  resetConfirmedPhone,
  confirmPhone,
  cleanLastRequestTime,
} from 'cityads-v3/actions/sms';

export default function FormPhone({ className, ...props }) {
  const { t } = useTranslation(['Publisher']);
  const dispatch = useDispatch();
  const owner = useSelector(state => state.header.bar.filter(item => item.type === 'owner')[0]);
  const isPhoneConfirmed = useSelector(state => state.sms.isPhoneConfirmed);

  const [isConfirming, setIsConfirming] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);
  const [error, setError] = useState(null);

  const changePhone = useCallback(async () => {
    setIsRequesting(true);

    try {
      if (isPhoneConfirmed) {
        await dispatch(resetConfirmedPhone());
      } else {
        await dispatch(confirmPhone());
      }

      setIsConfirming(true);
      setError(null);
    } catch (e) {
      setError(e.message);
    } finally {
      setIsRequesting(false);
    }
  }, [dispatch, isPhoneConfirmed, setIsConfirming, setIsRequesting, setError]);

  const closeConfirmationDialog = useCallback(() => {
    dispatch(resetSmsState());
    setIsConfirming(false);
  }, [dispatch]);

  const onConfirmPhone = useCallback(async () => {
    if (isPhoneConfirmed) {
      return await dispatch(resetConfirmedPhone());
    } else {
      return await dispatch(confirmPhone());
    }
  }, [dispatch, isPhoneConfirmed]);

  const onPhoneConfirmed = useCallback(async () => {
    dispatch(setCode(''));
    dispatch(cleanLastRequestTime(''));
  }, [dispatch]);

  return (
    <>
      <div className={className}>
        <WaitingButton
          color    = "primary"
          variant  = "contained"
          onClick  = {changePhone}
          disabled = {owner?.data?.sudo}
          waiting  = {isRequesting}
        >
          {isPhoneConfirmed ? t('phone.change') : t('phone.set')}
        </WaitingButton>
        <FormHelperText error={!!error}>{error}</FormHelperText>
      </div>

      <SmsDialog
        open              = {isConfirming}
        onClose           = {closeConfirmationDialog}
        onConfirmAction   = {onConfirmPhone}
        onActionConfirmed = {onPhoneConfirmed}
        variant           = {SMS_DIALOG_VARIANT_CREATE_PAYMENT}
      />
    </>
  );
}
